/**
 * useFlagshipIds — single source of truth for which experiments have Guided Flow.
 *
 * Fetches /api/guided/flagship-ids once on mount and caches the result in module
 * scope so subsequent components hydrate instantly. Bootstraps from the static
 * HAS_GUIDED set so the "Guided" toggle appears immediately on first render.
 */
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { HAS_GUIDED as BOOTSTRAP } from "@/components/3d/Simulation3DCanvas";

let cache = null;
let inflight = null;

async function loadOnce() {
  if (cache) return cache;
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const { data } = await api.get("/guided/flagship-ids");
      cache = new Set(data.ids || []);
    } catch (err) {
      console.warn("Failed to fetch flagship-ids, using bootstrap set:", err?.message || err);
      cache = new Set(BOOTSTRAP);
    } finally {
      inflight = null;
    }
    return cache;
  })();
  return inflight;
}

export function useFlagshipIds() {
  const [ids, setIds] = useState(() => cache || BOOTSTRAP);
  useEffect(() => {
    let alive = true;
    loadOnce().then((s) => { if (alive) setIds(s); });
    return () => { alive = false; };
  }, []);
  return ids;
}
